import api from '@/api'
import * as types from '../mutation-types'

import Moment from 'moment'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)

// Expected date format 20 Mei 2023
const newDateFromString = (dateString) => {
  const monthNumberDict = {
    'Januari': 0, 'Februari': 1, 'Maret': 2,
    'April': 3, 'Mei': 4, 'Juni': 5,
    'Juli': 6, 'Agustus': 7, 'September': 8,
    'Oktober': 9, 'November': 10, 'Desember': 11
  }
  const dateParts = dateString.split(' ')
  if (dateParts.length != 3) {
    return null
  }
  const datePart = dateParts[0]
  const monthPart = monthNumberDict[dateParts[1]]
  const yearPart = dateParts[2]
  return new Date(yearPart, monthPart, datePart)
}

// initial state
const state = {
  status: {},
  status_yudisium: {},
  status_yudisium_ok: false
}

// getters
const getters = {
  getStatusData: state => state.status,
  getStatusYudisium: state => state.status_yudisium,
  getStatusYudisiumOk: state => state.status_yudisium_ok
}

// actions
const actions = {
  getStatusPendaftar({ commit, dispatch }, data) {
    api.get(`/v2/status_pendaftar/${data.nomorPendaftar}/${data.kodePenawaran}`)
      .then(response => {
        let responseData = response.data
        // const tglPengumumanString = responseData.data.jadwal_pengumuman
        const dateNow = moment(responseData.data.time_now)
        const tglPengumuman = moment(responseData.data.jadwal_pengumuman)
        console.log('OKOKOKOKOKOKOKOK', dateNow.toDate())
        console.log('OKOKOKOKOKOKOKOK', tglPengumuman.toDate())
        if (dateNow.isAfter(tglPengumuman)) {
          dispatch('getStatusYudisium', { nomorPendaftar: data.nomorPendaftar })
        }
        // if (tglPengumumanString && (typeof tglPengumumanString == 'string')) {
        //   const tglPengumuman = newDateFromString(tglPengumumanString)
        //   if (tglPengumuman instanceof Date) {
        //     const dateNow = new Date();
        //     if (dateNow >= tglPengumuman) {
        //       dispatch('getStatusYudisium', { nomorPendaftar: data.nomorPendaftar })
        //     }
        //   }
        // }
        commit(types.STATUS_PENDAFTAR, { responseData })
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  },

  getStatusYudisium({ commit }, data) {
    api.get(`/v2/yudisium/${data.nomorPendaftar}`)
      .then(response => {
        let responseData = response.data
        commit(types.STATUS_YUDISIUM, { responseData })
      })
      .catch(e => {
        // FIXME: Tell our user when we got some errors
        console.log(e)
      })
  },

  resetStatus({ commit }){
    commit(types.RESET_STATUS)
  }
}

// mutations
const mutations = {
  [types.STATUS_PENDAFTAR](state, { responseData }) {
    state.status = responseData.data
  },
  [types.STATUS_YUDISIUM](state, { responseData }) {
    state.status_yudisium_ok = true
    state.status_yudisium = responseData.data
  },
  [types.RESET_STATUS](state) {
    state.status = {}
    state.status_yudisium = {}
    state.status_yudisium_ok = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/status-pendaftar.js